function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2498 28.1667H3.83317V7.75004H16.9582V4.83337H3.83317C2.229 4.83337 0.916504 6.14587 0.916504 7.75004V28.1667C0.916504 29.7709 2.229 31.0834 3.83317 31.0834H24.2498C25.854 31.0834 27.1665 29.7709 27.1665 28.1667V15.0417H24.2498V28.1667ZM12.8894 23.5438L10.0311 20.1021L6.02067 25.25H22.0623L16.8998 18.3813L12.8894 23.5438ZM27.1665 4.83337V0.458374H24.2498V4.83337H19.8748C19.8894 4.84796 19.8748 7.75004 19.8748 7.75004H24.2498V12.1105C24.2644 12.125 27.1665 12.1105 27.1665 12.1105V7.75004H31.5415V4.83337H27.1665Z",
  fill: "#B6B6B6"
});

function SvgIcnPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPost);
export default __webpack_public_path__ + "static/media/icn_post.196302ef.svg";
export { ForwardRef as ReactComponent };